import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@repo/components';
import GenericDataPageHeader from 'src/components/GenericDataPageHeader';
import { TemplateApiResponse } from '@repo/shared/domain';
import { useBreadcrumbLevel } from '@repo/components/hooks';
import { getTemplates } from 'src/api/admin/system';

export const Route = createFileRoute('/_admin/system/templates/')({
	loader: async () => {
		const templates = await getTemplates();
		return { templates };
	},
	component: TemplatesPage,
});

const columns = [
	{
		field: 'id',
		headerName: 'Name',
		flex: 1,
	},
	{
		field: 'recipients',
		headerName: 'Recipients',
		flex: 1,
	},
	{
		field: 'trigger',
		headerName: 'Trigger',
		flex: 1,
	},
	{
		field: 'description',
		headerName: 'Description',
		flex: 1,
	},
];

function TemplatesPage() {
	const { templates: initialTemplates } = Route.useLoaderData();
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const { data: templates, refetch: revalidateTemplates } = useQuery({
		queryKey: ['templates'],
		queryFn: () => getTemplates(),
		initialData: initialTemplates,
	});

	useBreadcrumbLevel(0, 'System');
	useBreadcrumbLevel(1, 'Templates');

	const handleRowClick = ({ row }: { row: { id: string } }) => {
		navigate({ to: '/system/templates/$id', params: { id: row.id } });
	};

	return (
		<>
			<GenericDataPageHeader />
			<div className="p-4">
				<Paper variant="outlined">
					<DataGrid
						data={templates.data}
						rowCount={templates.data.length}
						pageSize={templates.data.length}
						columns={columns}
						paginationMode="server"
						sortingMode="server"
						sortingOrder={['asc', 'desc']}
						onRowClick={handleRowClick}
						onReload={revalidateTemplates}
					/>
				</Paper>
			</div>
		</>
	);
}
